(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  // BravoSafe Modal functionality
  function initBravoSafeModal() {
    const modalOverlay = document.getElementById('bravosafe-modal-overlay');
    
    if (!modalOverlay) {
      // Se il modal non esiste ancora, riprova dopo un breve delay
      setTimeout(initBravoSafeModal, 100);
      return;
    }

    function openModal(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (modalOverlay) {
        modalOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeModal(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (modalOverlay) {
        modalOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    }
    
    // Event delegation per gestire click su elementi aggiunti dinamicamente
    document.addEventListener('click', function(e) {
      // Apri modal quando si clicca sul pulsante info o su qualsiasi elemento dentro
      const infoBtn = e.target.closest('.bravosafe-info-btn');
      if (infoBtn) {
        openModal(e);
        return;
      }
      
      // Chiudi modal quando si clicca sul pulsante close (solo se è dentro QUESTO overlay)
      if (e.target.closest('#bravosafe-modal-overlay') && e.target.closest('.bravosafe-modal__close')) {
        closeModal(e);
        return;
      }
      
      // Chiudi modal quando si clicca sul pulsante OK (solo se è dentro QUESTO overlay, non nel checkout modal)
      if (e.target.closest('#bravosafe-modal-overlay') && e.target.closest('.bravosafe-modal__ok-btn')) {
        closeModal(e);
        return;
      }
      
      // Chiudi modal quando si clicca sull'overlay (fuori dal modal)
      if (e.target === modalOverlay && modalOverlay.classList.contains('active')) {
        closeModal(e);
        return;
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modalOverlay && modalOverlay.classList.contains('active')) {
        closeModal(e);
      }
    });
  }
  
  // Inizializza quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBravoSafeModal);
  } else {
    initBravoSafeModal();
  }

  // Checkout modal: come bravosafe-card usa section render / AJAX → il pulsante viene sostituito
  // dopo ogni cart update, quindi usiamo event delegation e leggiamo sempre data-bravosafe-in-cart
  // dal pulsante corrente (aggiornato dal server).
  function initCheckoutModal() {
    const checkoutOverlay = document.getElementById('checkout-modal-overlay');
    const checkoutCloseBtn = document.getElementById('checkout-modal-close-btn');
    const checkoutConfirmBtn = document.getElementById('checkout-modal-confirm-btn');

    if (!checkoutOverlay) return;

    function openCheckoutModal(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      checkoutOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      checkoutOverlay.setAttribute('aria-hidden', 'false');
    }

    function closeCheckoutModal(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      checkoutOverlay.classList.remove('active');
      document.body.style.overflow = '';
      checkoutOverlay.setAttribute('aria-hidden', 'true');
    }

    // Delegation: il pulsante checkout è dentro main-cart e viene sostituito ad ogni cart update
    // (come bravosafe-card--in-footer). Leggiamo data-bravosafe-in-cart dal pulsante cliccato.
    document.addEventListener('click', function(e) {
      const checkoutBtn = e.target.closest('#cart-checkout-btn');
      if (!checkoutBtn) return;
      if (checkoutBtn.getAttribute('data-bravosafe-in-cart') === 'false') {
        e.preventDefault();
        e.stopPropagation();
        openCheckoutModal(e);
      }
    });

    // Chiudi modal (X o click fuori)
    if (checkoutCloseBtn) checkoutCloseBtn.addEventListener('click', closeCheckoutModal);
    checkoutOverlay.addEventListener('click', function(e) {
      if (e.target === checkoutOverlay) closeCheckoutModal(e);
    });

    // "Completa l'ordine" → vai al checkout
    if (checkoutConfirmBtn) {
      checkoutConfirmBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        closeCheckoutModal(e);
        window.location.href = '/checkout';
      });
    }

    // Escape chiude il checkout modal
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && checkoutOverlay.classList.contains('active')) {
        closeCheckoutModal(e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCheckoutModal);
  } else {
    initCheckoutModal();
  }

  // Offerte danni accidentali: niente form annidati nel form carrello
  // (il primo </form> interno chiudeva il form cart e rompeva il 1° switch)
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.accidental-damage-offers__switch-input');
    if (!input || !input.checked) return;

    var offer = input.closest('[data-accidental-damage-offer]');
    if (!offer) return;

    var variantId = Number(offer.getAttribute('data-variant-id'));
    if (!variantId) return;

    input.disabled = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              _accidental_damage_parent_key: offer.getAttribute('data-parent-key') || '',
              _accidental_damage_parent_title: offer.getAttribute('data-parent-title') || '',
            },
          },
        ],
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        window.location.href = root + 'cart';
      })
      .catch(function () {
        input.disabled = false;
        input.checked = false;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  (function () {
    const STORAGE_KEY = 'bb_register_submitted';
    const form = document.getElementById('create_customer');
    const formWrapper = document.getElementById('RegisterFormWrapper');
    const success = document.getElementById('RegisterSuccess');

    if (!form || !formWrapper || !success) return;

    form.addEventListener('submit', () => {
      sessionStorage.setItem(STORAGE_KEY, '1');
    });

    const wasSubmitted = sessionStorage.getItem(STORAGE_KEY) === '1';
    const isLoggedIn = success.dataset.customerLoggedIn === 'true';

    if (wasSubmitted && isLoggedIn) {
      sessionStorage.removeItem(STORAGE_KEY);
      formWrapper.classList.add('hidden');
      success.classList.remove('hidden');
      success.hidden = false;
      success.querySelector('[tabindex="-1"]')?.focus();

      const homeUrl = window.FoxTheme?.routes?.root_url || '/';
      window.setTimeout(() => {
        window.location.assign(homeUrl);
      }, 5000);
    } else if (wasSubmitted) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
